import { httpRequest } from "@services/http"

export type AdTag = {
  id: number
  name: string
}

export type AdTagGroup = {
  id: number
  name: string
  color: string | null
  tags: AdTag[]
}

/** Tags for every ad in the engagement, keyed by ad id. */
export type EngagementAdTags = Record<number, AdTagGroup[]>

/*
    Content Catalog tags for a whole engagement in one request (MPN-1506). The schedule
    and monitor pages show tags against every ad they list, so asking per ad would be one
    request per row.

    Tags are read-only here — they are managed in the Content Catalog and only displayed.
*/
export class CommandGetEngagementAdTags {
  async run(engagementId: number): Promise<EngagementAdTags> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/ad-tags/`
    const response = await httpRequest<EngagementAdTags>(url, { method: "GET" })
    return response ?? {}
  }
}
